// extracted by mini-css-extract-plugin
export default {"Text":"time-bound-filter-warning-module__Text__xNwh_ud","Box":"time-bound-filter-warning-module__Box__itgqFgt"};